export default function Section({ children, className })  {
    return (
        <section className={className ? className : ''}>
            <div className="section-content">
                {children}
            </div>
        </section>
    )
}
